module.exports = __webpack_public_path__ + "img/team-1-3.db1d5602.jpeg";